<div class="snack-bar-message"
     [style.background-color]="notificationMessageData.backgroundColor"
     (click)="closeSnackBar()">
  {{ notificationMessageData.message }}
</div>
